<template>
  <div class="Spinner" />
</template>

<script setup>
</script>

<style scoped>
  .Spinner {
    border: 16px solid #f3f3f3;
    border-top: 16px solid #3498db;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 1s linear infinite;
    align-content: center;
    margin: 0 auto;
  }

  @keyframes spin {
    to {
      transform: rotateZ(360deg);
    }
  }
</style>
